var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarsMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5.8l-1.325.81a.5.5 0 01-.747-.543l.36-1.51-1.18-1.011a.5.5 0 01.286-.878l1.548-.124.596-1.434a.5.5 0 01.924 0l.596 1.434 1.548.124a.5.5 0 01.285.878l-1.18 1.01.361 1.51a.5.5 0 01-.747.543L4 5.8zM12 5.8l-1.325.81a.5.5 0 01-.747-.543l.36-1.51-1.18-1.011a.5.5 0 01.286-.878l1.548-.124.596-1.434a.5.5 0 01.924 0l.596 1.434 1.548.124a.5.5 0 01.285.878l-1.18 1.01.361 1.51a.5.5 0 01-.747.543L12 5.8zM20 5.8l-1.325.81a.5.5 0 01-.747-.543l.36-1.51-1.18-1.011a.5.5 0 01.286-.878l1.548-.124.596-1.434a.5.5 0 01.924 0l.596 1.434 1.548.124a.5.5 0 01.285.878l-1.18 1.01.361 1.51a.5.5 0 01-.747.543L20 5.8zM28 5.8l-1.325.81a.5.5 0 01-.747-.543l.36-1.51-1.18-1.011a.5.5 0 01.286-.878l1.548-.124.596-1.434a.5.5 0 01.924 0l.596 1.434 1.548.124a.5.5 0 01.285.878l-1.18 1.01.361 1.51a.5.5 0 01-.747.543L28 5.8z",
    fill: "#CDDEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 5.8l-1.325.81a.5.5 0 01-.747-.543l.36-1.51-1.18-1.011a.5.5 0 01.286-.878l1.548-.124.596-1.434a.5.5 0 01.924 0l.596 1.434 1.548.124a.5.5 0 01.285.878l-1.18 1.01.361 1.51a.5.5 0 01-.747.543L36 5.8z",
    fill: "#0248C3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2 2.555l-.142-.011-.597-1.434a.5.5 0 00-.923 0l-.596 1.434-1.548.124a.5.5 0 00-.285.878l1.179 1.01-.36 1.51a.5.5 0 00.747.543L36 5.8l1.2.733V2.555z",
    fill: "#CDDEFF"
  })));
}
export default SvgStarsMobile;